import { FC, useEffect, useState } from 'react'
import * as S from './styles'
import { Icon, Input, Loader } from '@/client/components'
import { useRouterPush } from '@/client/hooks'

export const BlogSearch: FC<any> = ({ search_placeholder, search_result }) => {
  const [searchValue, setSearchValue] = useState<string>('')
  const [loader, setLoader] = useState(false)
  const { routerPush, asPath } = useRouterPush()
  const serachAction = () => {
    routerPush(`/blog/search/${searchValue}/page/1`)
  }

  useEffect(() => {
    setLoader(false)
  }, [asPath])
  return (
    <S.SearchBox
      onSubmit={(e) => {
        e.preventDefault()
        setLoader(true)
        routerPush(`/blog/search/${searchValue}/page/1`)
      }}
    >
      {/* Search box */}
      <Input
        isBlock
        id='input-search'
        name='search'
        type='search'
        disabled={loader}
        placeholder={search_placeholder}
        value={searchValue}
        onChange={(e) => setSearchValue(e.currentTarget.value)}
        autoComplete='off'
        rightElement={
          <S.SearchIcon>
            {loader ? (
              <Loader size='small' />
            ) : (
              <S.SearchIconWrapper
                onClick={(e) => {
                  e.stopPropagation()
                  setLoader(true)
                  serachAction()
                }}
              >
                <Icon name='search' size='s5' />
              </S.SearchIconWrapper>
            )}
          </S.SearchIcon>
        }
      />
      <S.Divider />
    </S.SearchBox>
  )
}
